import styled from "styled-components";

// Define bounds and padding for main container
const StyledContainerDesktop = styled.div`
  && {
    padding: 0;
    height: 100%;
    max-width: 1320px;
    padding-left: 60px;
    padding-right: 60px;
    margin: 30px auto;
    // Allows proper font rendering on Storybook
    -webkit-font-smoothing: antialiased;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      * {
        flex: 1 1 auto;
      }
    }
  }
`;

const StyledContainerTablet = styled.div`
  && {
    padding: 0;
    height: 100%;
    // max-width: 835px;
    padding-left: 40px;
    padding-right: 40px;
    margin: ${({ isHomepage }) => (isHomepage ? "80px auto" : "70px auto")};
    // Allows proper font rendering on Storybook
    -webkit-font-smoothing: antialiased;
  }
`;

const StyledContainerMobile = styled.div`
  && {
    padding: 0;
    height: 100%;
    // max-width: 375px;
    padding-left: 16px;
    padding-right: 16px;
    margin: ${({ isHomepage }) => (isHomepage ? "80px auto" : "70px auto")};
    // Allows proper font rendering on Storybook
    -webkit-font-smoothing: antialiased;
  }
`;

export { StyledContainerDesktop, StyledContainerTablet, StyledContainerMobile };
